// extracted by mini-css-extract-plugin
export default {"container":"ModalHumidifierDisconnected_container__87xM6","description":"ModalHumidifierDisconnected_description__MJ0Xa"};